import { Component } from '@angular/core';

@Component({
  selector: 'app-accessibility-notice',
  templateUrl: './accessibility-notice.component.html',
  styleUrl: './accessibility-notice.component.scss'
})

export class AccessibilityNoticeComponent {

}
